module.exports = __webpack_public_path__ + "img/ic_16_fitnessplan-error.14f45445.svg";